import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type LayoutStore = {
  isDrawerOpen: boolean;
  expandedItems: Record<string, boolean>;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
  toggleItem: (label: string) => void;
};

export const useLayout = create<LayoutStore>()(
  persist(
    (set) => ({
      isDrawerOpen: false,
      expandedItems: {},
      openDrawer: () => set({ isDrawerOpen: true }),
      closeDrawer: () => set({ isDrawerOpen: false }),
      toggleDrawer: () => set((state) => ({ isDrawerOpen: !state.isDrawerOpen })),
      toggleItem: (label) =>
        set((state) => ({
          expandedItems: { ...state.expandedItems, [label]: !state.expandedItems[label] },
        })),
    }),
    { name: 'layout' },
  ),
);
